var shipping_message_app = function () {
  var app = {};

  function handlePageElements () {
     $('.free-ship').css({ display: 'block' });
     $('.free-ship').animate({ marginTop: '0' }, 600);
     $('.ship-x').click( function (e) {
        e.preventDefault();
        $('.free-ship').animate({ marginTop : '-30px' }, 400 );
    });
  };

  checkIfUserKnows = function () {
    var fresh = false,
     sDate,
     freshness = 0
     day = 86400000;
     if(window.localStorage) {
      sDate = localStorage.getItem('moonapparel_shippingmessage');
      freshness = new Date() - new Date(sDate);
      if(freshness < day ) { fresh = true; }
    }
    return fresh;
  };

  app.initialize = function () {
    var fresh = checkIfUserKnows();
    if(fresh !== true) {
      if(window.localStorage) {
        localStorage.setItem('moonapparel_shippingmessage', new Date() );
      }
      handlePageElements();
    }
  };

  return app;
}();